import s from './StatusChip.module.css';

export type StatusChipTone = 'success' | 'warning' | 'danger' | 'neutral';

type StatusChipProps = {
  label: string;
  tone?: StatusChipTone;
};

const TONE_CLASSES: Record<StatusChipTone, string> = {
  success: s.success,
  warning: s.warning,
  danger: s.danger,
  neutral: s.neutral,
};

function StatusChip({ label, tone = 'neutral' }: StatusChipProps) {
  return (
    <span className={`${s.chip} ${TONE_CLASSES[tone]}`}>
      <span className={s.dot} />
      <span className={s.label}>{label}</span>
    </span>
  );
}

export default StatusChip;
